'use client';

import { Box, Flex } from '@coolblue-development/freddy';
import useTestId from '@hooks/useTestId';
import { Fragment } from 'react';

import {
  type CollectionProps,
  CollectionType,
  PresentationFormat,
  Variant
} from '../Collection.types';
import { CollectionColorPicker, CollectionTitle } from '../Shared';
import { PropertyCards } from './PropertyCards';

export const PropertyCollection = ({
  collection,
  mainImageId,
  onProductClick,
  product,
  variant = Variant.DESKTOP,
  selectedProductId
}: CollectionProps) => {
  const isMobile = variant === Variant.MOBILE;
  const shouldShowCollectionTitle =
    !isMobile && collection.discriminants && collection.discriminants.length > 1;
  const testIdPropertyCards = useTestId('property-cards');

  return (
    <>
      {shouldShowCollectionTitle && (
        <CollectionTitle title={collection.title} productType={product.productType} />
      )}
      <Flex gap={400} direction='column'>
        {collection.discriminants.map((discriminant, discriminantIndex) => {
          if (
            !discriminant.values ||
            discriminant.values.length === 0 ||
            discriminant.values.filter(value => value.shouldShowValue).length <= 1
          ) {
            return <Fragment key={discriminantIndex} />;
          }

          return discriminant.presentationFormat === PresentationFormat.CARDS_WITH_IMAGES ? (
            <CollectionColorPicker
              key={`color-${discriminantIndex}`}
              discriminant={discriminant}
              index={discriminantIndex}
              onProductClick={onProductClick}
              variant={variant}
              selectedProductId={selectedProductId}
              collectionType={CollectionType.PROPERTY}
            />
          ) : (
            <Box key={`card-${discriminantIndex}`} {...testIdPropertyCards}>
              <PropertyCards
                discriminant={discriminant}
                mainImageId={mainImageId}
                onProductClick={onProductClick}
                product={product}
                shouldShowCollectionTitle={shouldShowCollectionTitle}
                variant={variant}
              />
            </Box>
          );
        })}
      </Flex>
    </>
  );
};
